import { type Layer, type HXKLineLayerSpec, defineHXKLineLayer } from '../../../core/layer';
import type { StockData } from '../../../helper/hxKLine';
import type { StandardChartView } from '../../../core/MainStandardChartView';

const visInfo: Layer['visInfo'] = {
  id: 'simpleKLine',
  name_en: 'Simple Candlestick Chart',
  name_zh: '简单版行情图',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  parameters: {},
  extra: {
    isNotTrainedByLLM: true
  }
};

export interface Spec extends HXKLineLayerSpec {
  stocks: StockData[];
}

export const layer = defineHXKLineLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec, $dom, standardChartView: StandardChartView) {
    const dateAxisData = standardChartView.getDateAxisData(api);
    const dataZoomData = standardChartView.getDataZoomData();

    const klineIns = api.hook.addSubChartSimpleHXKLine(api, {
      container: $dom,
      stocks: spec.stocks,
      selectedStock: String(spec.stocks[standardChartView.selectedStockIndex].code),
      klineLegendIns: standardChartView.legendIns.klineDropdown[0],
      dates: dateAxisData,
      dateStartIndex: dataZoomData?.startValue,
      dateEndIndex: dataZoomData?.endValue,
      xAxisIsDate: dateAxisData.length > 0,
      enableDataZoom: !!dataZoomData,
      chartIns: standardChartView.chartIns,
      enableTimeline: !!standardChartView.timelineIns,
      timelineIns: standardChartView.timelineIns,
      cardDom: $dom.parentElement!
    });

    return () => {
      klineIns?.destroy?.();
    };
  }
});
